import { Injectable } from '@angular/core';
import { ANALYTICS_EVENTS } from '../data-models/constants/analytics-extended.constant';
import {
  HEADER_MENU,
  USER_LOGGED_IN_STATUS
} from '../data-models/constants/analytics.constant';
import { removeDomainName } from '../regexp/regex-patterns';
import { ClickEventAnalytics } from './analytics.interfaces';
import { ContentBodyExtendedHelperAnalytics } from './content-body-extended-helper-analytics.service';
@Injectable({
  providedIn: 'root'
})
export class ContentBodyAbodeSupportAnalytics extends ContentBodyExtendedHelperAnalytics {
  private static clickListenerAdded = false;
  setupGlobalClickListener(): void {
    if (!ContentBodyAbodeSupportAnalytics.clickListenerAdded) {
      document.addEventListener('click', (event) => {
        const target = event.target as HTMLElement;
        const heroEl = target.closest(
          '.d-flex.hero-home-text-container.flex-column'
        );
        const tileEl = target.closest('.section.cardcd.card-d');
        const bannerEl = target.closest('.cardb.parbase.container');

        if (heroEl) this.handleCardClick(event, ANALYTICS_EVENTS.HERO_CLICK);
        else if (tileEl)
          this.handleCardClick(event, ANALYTICS_EVENTS.TILE_CLICK);
        else if (bannerEl)
          this.handleCardClick(event, ANALYTICS_EVENTS.BANNER_CLICK);
      });
      ContentBodyAbodeSupportAnalytics.clickListenerAdded = true;
    }
  }

  handleCardClick(event: Event, eventDetail: string): void {
    try {
      const clickedElement = event.target as HTMLElement;
      if (!clickedElement) return;

      const closestAnchor = clickedElement.closest('a');
      if (!closestAnchor) return;

      event.preventDefault();
      this.processClickAnalytics(clickedElement, closestAnchor, eventDetail);
      this.navigateToUrl(closestAnchor);
    } catch (error) {
      console.error('Error handling card click:', error);
    }
  }

  private processClickAnalytics(
    clickedElement: HTMLElement,
    closestAnchor: HTMLAnchorElement,
    eventDetail: string
  ): void {
    const contentInfo = this.getContentInfo(clickedElement);
    const eventType = closestAnchor.getAttribute('href') ? 'link' : 'click';
    const fullUrl =
      this.getFullUrl(closestAnchor)?.replace(removeDomainName, '') || '';
    const cleanUrl =
      this.analyticsService?.removeCountryLanguageFromUrl(fullUrl) || fullUrl;
    this.handleAnalytics(contentInfo, eventType, cleanUrl, eventDetail);
  }

  private navigateToUrl(anchor: HTMLAnchorElement): void {
    const fullUrl = this.getFullUrl(anchor);
    if (fullUrl) {
      window.location.href = fullUrl;
    }
  }

  getFullUrl(anchor: HTMLAnchorElement): string {
    const href = anchor?.getAttribute('href') || '';
    if (!href) return '';

    try {
      return new URL(href, window.location.origin).href;
    } catch (error) {
      console.error('Error getting full URL:', error);
      return href;
    }
  }

  handleAnalytics(
    contentInfo: { clicked: string; parent?: string },
    eventType: string,
    fullUrl: string,
    eventDetail: string
  ): void {
    this.setHomePageClickAnalytics(
      contentInfo,
      eventType,
      fullUrl,
      eventDetail
    );
  }

  setHomePageClickAnalytics(
    contentInfo: { clicked: string; parent?: string },
    eventType: string,
    fullUrl: string,
    eventDetail: string
  ): void {
    const text = this.getComponentName(eventDetail);
    const data: ClickEventAnalytics = {
      event: ANALYTICS_EVENTS.CLICK,
      event_detail: eventDetail,
      click: {
        name: contentInfo.clicked,
        type: eventType,
        component_type: text,
        component_name:
          contentInfo.parent == undefined
            ? contentInfo.clicked
            : contentInfo.parent,
        page_section: HEADER_MENU.HOMEPAGE.PAGE_SECTION + text,
        action: fullUrl
      },
      user: {
        attributes: {
          is_logged_in: this.isLoggedInGlobal
            ? USER_LOGGED_IN_STATUS.AUTHENTICATED
            : USER_LOGGED_IN_STATUS.UNAUTHENTICATED
        }
      }
    };
    this.analyticsService.setAnalytics(data);
  }
}
